import React, { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useEvent } from 'react-use';
import {
  Button,
  Chevron,
  NotificationDialog,
  createAccessibleOnClick,
} from '@surfline/quiver-react';
import { color } from '@surfline/quiver-themes';
import {
  getMeterRemaining,
  trackClickedSubscribeCTA,
  trackEvent,
  getUserFreeTrialEligible,
} from '@surfline/web-common';

import config from '../../../../config';

const RATE_LIMIT_CARD = 'Rate Limit Card';

const SurfCheckCounter = () => {
  const meterRemaining = useSelector(getMeterRemaining);
  const isFreeTrialEligible = useSelector(getUserFreeTrialEligible);
  const [expanded, setExpanded] = useState(true);

  const handleOnScroll = useCallback(() => {
    if (expanded) {
      setTimeout(() => {
        setExpanded(false);
      }, 300);
    }
    if (window.scrollY === 0) {
      setExpanded(true);
    }
  }, [expanded]);

  const onClickCTA = useCallback(() => {
    trackEvent('CLICKED_POPUP', {
      action: 'Clicked CTA',
      category: RATE_LIMIT_CARD,
    });
    trackClickedSubscribeCTA({
      location: RATE_LIMIT_CARD,
      checksRemaining: meterRemaining,
      platform: 'web',
    });
    setTimeout(() => {
      window.location.assign(`${config.funnelUrl}`);
    }, 500);
  }, [meterRemaining]);

  const counterClicked = () => {
    setTimeout(() => {
      setExpanded(!expanded);
    }, 10);
  };

  useEvent('scroll', handleOnScroll);

  const counterText = meterRemaining !== 0 ? 'Surf Checks' : 'Surf Check';

  const subHeaderText = 'Your 3 Surf Checks renew every Monday. Want unlimited access? Go Premium.';

  const counterClickProps = createAccessibleOnClick(counterClicked, 'BTN');

  return (
    <div className="sl-surf-check-counter" {...counterClickProps}>
      <NotificationDialog
        title={
          <div className="sl-surf-check-counter__box-header">
            <h5 className="sl-surf-check-counter__box-title">You have</h5>
            <div className="sl-surf-check-counter__count">
              <span>
                {meterRemaining + 1} {counterText}
              </span>
            </div>
            <h5 className="sl-surf-check-counter__box-title">left</h5>
            <div className="sl-surf-check-counter__chevron">
              <Chevron direction={expanded ? 'up' : 'down'} />
            </div>
          </div>
        }
        expanded={expanded}
        bgColor={color('gray', 10)}
      >
        <p className="sl-surf-check-counter__box-text">{subHeaderText}</p>
        <Button onClick={onClickCTA}>
          {isFreeTrialEligible ? 'START FREE TRIAL' : 'GO PREMIUM'}
        </Button>
      </NotificationDialog>
    </div>
  );
};

export default SurfCheckCounter;
